

























// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const navigator: any
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Link } from '@/models/link'
import { getShareUrl } from '@/utils'

@Component
export default class LinkShare extends Vue {
  @Prop({ type: Object, required: true })
  link!: Link
  labelCopy = 'copy'

  share() {
    navigator.share({
      title: document.title,
      text: `Deep link: ${this.link.name}`,
      url: this.urlToShare
    })
  }

  async copy() {
    await navigator.clipboard.writeText(this.urlToShare)
    this.labelCopy = 'copied!'
    setTimeout(() => {
      this.labelCopy = 'copy'
    }, 1500)
  }

  get canCopy() {
    return !!navigator.clipboard
  }

  get canShare() {
    return !!navigator.share
  }

  get urlToShare(): string {
    return getShareUrl(this.link)
  }
}
